module.exports = __webpack_public_path__ + "static/media/ste_2009_avezzano_2.7ea58c6b.jpg";